export default "__VITE_ASSET__AXH_C1EH__"